const appRouters: Array<any> = [{
    path: '/reportstatistics',
    name: 'reportstatistics',
    sort: 4,
    meta: { title: 'app.Menu.ReportStatistics', showAlways:true,  icon: 'md-list-box' },
    component: () => import('../shared/main/index.vue'),
    children: [
        {
            path: 'amountstatistics', meta: { title: 'app.AmountStatistics', access: ['RIMS.AmountStatistics'], icon: '', defaultChild: 'amountstatistics.list' },
            name: 'amountstatistics', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'amountstatistics', meta: { title: 'app.AmountStatistics', access: ['RIMS.AmountStatistics'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'amountstatistics.list', component: () => import('./amountstatistics/index.vue'),
                },
            ]
        },
        {
            path: 'exportprofit', meta: { title: 'app.ExportProfit', access: ['RIMS.ExportProfit'], icon: '', defaultChild: 'exportprofit.list' },
            name: 'exportprofit', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.ExportProfit', access: ['RIMS.ExportProfit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'exportprofit.list', component: () => import('./exportprofit/index.vue'),
                },
            ]
        },
        {
            path: 'domesticsalesprofit', meta: { title: 'app.DomesticSalesProfit', access: ['RIMS.DomesticSalesProfit'], icon: '', defaultChild: 'domesticsalesprofit.list' },
            name: 'domesticsalesprofit', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.DomesticSalesProfit', access: ['RIMS.DomesticSalesProfit'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'domesticsalesprofit.list', component: () => import('./domesticsalesprofit/index.vue'),
                },
            ]
        },
    ]
}
]

export default appRouters